import React from "react"
import classNames from "classnames"

/** Quiet cycle mark — not a toy die. Two arcs + tips. */
export default function RerollIcon({
  className,
}: {
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("h-4 w-4", className)}
      aria-hidden
    >
      <path
        d="M5.2 9.2A7.2 7.2 0 0 1 17.5 7.1"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M16.2 3.8v3.6h3.6"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8 14.8A7.2 7.2 0 0 1 6.5 16.9"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M7.8 20.2v-3.6H4.2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
